import { render, staticRenderFns } from "./policSettings.vue?vue&type=template&id=6779be1d&scoped=true&"
import script from "./policSettings.vue?vue&type=script&lang=js&"
export * from "./policSettings.vue?vue&type=script&lang=js&"
import style0 from "./policSettings.vue?vue&type=style&index=0&id=6779be1d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6779be1d",
  null
  
)

export default component.exports